export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9485.d1d8219c.jpg";